import { AxiosResponse } from 'axios'
import { FIREBASE_STATUSES } from '../constants'

export const usePolling = () => {
  const poll = async ({
    request,
    successCallback,
    pollingInterval = 5000,
    maxPollingDuration = 7200000
  }: {
    request: () => Promise<AxiosResponse<unknown>>
    successCallback: (data: unknown) => void
    pollingInterval?: number
    maxPollingDuration?: number
  }) => {
    const startTime = Date.now() // Record the start time

    const makeRequest = async () => {
      try {
        const data = await request()
        const responseData = data.data as {
          notification_status?: string
          status?: string
        }
        const notificationStatus =
          responseData?.notification_status ?? responseData?.status

        if (notificationStatus !== FIREBASE_STATUSES.IN_PROGRESS) {
          successCallback(data.data)
        }

        const elapsedTime = Date.now() - startTime

        if (
          elapsedTime < maxPollingDuration &&
          notificationStatus === FIREBASE_STATUSES.IN_PROGRESS
        ) {
          setTimeout(makeRequest, pollingInterval) // Schedule next request
        } else {
          // eslint-disable-next-line no-console
          console.log('Maximum polling duration reached. Stopping polling.')
        }
      } catch (error) {
        console.error('Error making API request:', error)
        const elapsedTime = Date.now() - startTime

        if (elapsedTime < maxPollingDuration) {
          setTimeout(makeRequest, pollingInterval) // Schedule next request
        } else {
          // eslint-disable-next-line no-console
          console.log('Maximum polling duration reached. Stopping polling.')
        }
      }
    }
    makeRequest()
  }

  return {
    poll
  }
}
